
import styled from 'styled-components'

import LAYOUT from 'constants/layout'
import MEDIA from 'constants/media'


export const ContactInfoWrap = styled.div<{img: string, isLoading: boolean}>`
  background-image: url(${(props): string => props.img});
  background-size: cover;
  padding: ${LAYOUT.VERTICALSPACEMOBILE} 20px;
  transition: all 0.5s linear;
  ${(props): string | false => props.isLoading && 'filter: blur(10px);'}
  ${MEDIA.medium`
    padding: ${LAYOUT.VERTICALSPACE} 20px;
  `}
`

export const SubpageSection = styled.div`
  max-width: 800px;
  margin: auto;
  text-align: center;
`
